import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { Database, Users, MapPin, Award } from 'lucide-react';

const StatsSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stats = [
    {
      icon: Database,
      value: 50000,
      suffix: '+',
      label: 'Geprüfte Kontakte',
      description: 'Valide Firmenadressen'
    },
    {
      icon: MapPin,
      value: 200,
      suffix: '+',
      label: 'Städte & Gemeinden',
      description: 'Vollständige Abdeckung'
    },
    {
      icon: Users,
      value: 15,
      suffix: '+',
      label: 'Branchen',
      description: 'Diverse Geschäftsfelder'
    },
    {
      icon: Award,
      value: 95,
      suffix: '%',
      label: 'E-Mail-Abdeckung',
      description: 'Direkter Kontakt möglich'
    }
  ];

  return (
    <section ref={ref} className="py-24 bg-gradient-to-br from-[#2835F7] to-[#1a25c9] relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Beeindruckende Zahlen
          </h2>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Unsere Datenbank wächst täglich und bietet Ihnen Zugang zu tausenden qualifizierten B2B-Leads.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
              className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 text-center hover:bg-white/20 transition-all duration-300 hover:scale-105 border border-white/20 shadow-xl"
            >
              <stat.icon className="w-12 h-12 text-white mx-auto mb-4" />
              <div className="text-5xl font-bold text-white mb-2">
                {inView && (
                  <CountUp
                    end={stat.value}
                    duration={2.5}
                    separator="."
                    suffix={stat.suffix}
                  />
                )}
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{stat.label}</h3>
              <p className="text-white/80">{stat.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;